import React from 'react'
import JobModuleBase from '../JobModuleBase'
import PropTypes from 'prop-types'
import FunctionUtils from '../../../../lambda/FunctionUtils'
import wrapWithCustomerSelection from 'customer/CustomerSelectionWrapper'
import EditCustomerDialog from 'customer/CustomerInterfaces/EditCustomerDialog'
import EditCustomerWarningDialog from 'customer/common/WarningDialog'

class NameDescriptionModule extends JobModuleBase {

  static propTypes = {
    jobInfo: PropTypes.shape()
  }

  constructor(props) {
    super(props)
    const newState = this.returnNewState(props.customer, props.contact)
    this.state = {
      showCustomerEditWarningModal: false,
      showCustomerEditDialog: false,
      ...newState}
  }

  componentWillReceiveProps(nextProps){
    if (this.props.customer !== nextProps.customer
        || this.props.contact !== nextProps.contact){
      const newState = this.returnNewState(nextProps.customer, nextProps.contact)
      this.setState(newState)
      this.saveNewInformation(
        nextProps.jobInfo,
        nextProps.customerId,
        nextProps.customer,
        nextProps.contactId,
        nextProps.contact)
    }
  }

  returnNewState = (customer, contact) => {
    if (customer && contact){
      return {
        name: customer.name,
        id: customer.id,
        email: contact.email,
        address: contact.address,
        phoneNumber: contact.phoneNumber
      }
    }
  }

  saveNewInformation = (jobInfo, customerId, customer, contactId, contact) => {

    if (customer && contactId){
      const newContact = {
        //mutual information
        customerContactId: `${contactId}@${customerId}`,
        //customer information
        name: this.returnField(customer.name),
        id: this.returnField(customer.id),
        //contact information
        email : this.returnField(contact.email),
        phoneNumber: this.returnField(contact.phoneNumber),
        contactName: this.returnField(contact.contactName)
      }

      const newAddress = {
        value: this.returnField(contact.address),
        lat: this.returnField(contact.addressLat),
        lng: this.returnField(contact.addressLng)
      }

      FunctionUtils.updateModule(
        jobInfo,
        '/modules/contactInfo',
        newContact,
        true
      )

      FunctionUtils.updateModule(
        jobInfo,
        '/modules/address',
        newAddress,
        true
      )
    }
  }

  returnField(value){
    return value ? value : ''
  }

  handleEditCustomerWarning = () => {
    this.setState({showCustomerEditWarningModal: !this.state.showCustomerEditWarningModal})
  }

  denormalizeCustomerContact = (customer, contact) => {
    return {
      ...contact,
      name: customer.name,
      //company internal id, not fibo id
      customerId: customer.id
    }
  }

  proceedToEditCustomer = () => {
    const customerChosen = this.denormalizeCustomerContact(this.props.customer, this.props.contact)
    this.setState({
      customerChosen,
      showCustomerEditWarningModal: false,
      showCustomerEditDialog: true
    })
  }

  onEditRequestCompletion = () => {
    this.setState({ showCustomerEditDialog: false })
  }

  render() {
    if (!this.props.contact || !this.props.customer) {
      return null
    }

    return (
      <div style={styles.moduleContainer}>
        <div style={styles.nameIdContainer}>
          <input
            style={{ ...styles.input, ...styles.nameInput}}
            value={this.state.name}
            placeholder={'Business/Customer name'}
            readOnly={true}/>
          <input
            style={{ ...styles.input, ...styles.idInput}}
            value={this.state.id}
            placeholder={'Customer ID (office only)'}
            readOnly={true}/>
        </div>
        <div style={styles.addressContainer}>
          <input
            style={{ ...styles.input, ...styles.addressInput}}
            value={this.state.address}
            placeholder={'Address'}
            readOnly={true}/>
        </div>
        <div style={styles.contactContainer}>
          <div style={styles.contactInfoContainer}>
            <input
              style={{ ...styles.input, ...styles.contactEmail}}
              value={this.state.email}
              placeholder={'Email'}
              readOnly={true}/>
            <a href={`mailto:${this.state.email || ''}`}>
              <i className='fa fa-envelope' style={styles.mailTo} aria-hidden='true' title='Send email'></i>
            </a>
            <input
              style={{ ...styles.input, ...styles.contactPhone}}
              value={this.state.phoneNumber}
              placeholder={'Phone'}
              readOnly={true}/>
          </div>
        </div>

        <div style={styles.editCustomer} onTouchTap={this.handleEditCustomerWarning}>Edit Customer ...</div>

        <EditCustomerWarningDialog
          open={this.state.showCustomerEditWarningModal}
          title={'Edit Customer Warning'}
          message={'Editing this customer will change information of other events that are using the same customer'}
          onProceedClicked={this.proceedToEditCustomer}
          onCloseRequest={this.handleEditCustomerWarning}/>

        <EditCustomerDialog
          open={this.state.showCustomerEditDialog}
          teamId={this.props.teamId}
          customerId={this.props.customerId}
          item={this.state.customerChosen}
          onSave={this.onEditRequestCompletion}
          onCloseRequest={this.onEditRequestCompletion}/>
      </div>
    )
  }

}

const wrapperOptions = {
  showLabel: true,
  customerLabel: 'Add Customer',
  contactLabel: 'Add Contact'
}
export default wrapWithCustomerSelection(NameDescriptionModule, wrapperOptions)

const styles = {

  moduleContainer: {
    display: 'flex',
    flexDirection: 'column'
  },

  nameIdContainer: {
    display: 'flex',
    flexDirection: 'row'
  },

  input: {
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    backgroundColor: 'rgba(217, 217, 217, 0.75)',
    borderRadius: 3,
    boxShadow: 'inset 0 2px 2px 0 rgba(0, 0, 0, 0.05)',
    border: 'solid 1px rgba(0, 0, 0, 0.12)'
  },

  nameInput: {
    width: '50%',
    marginRight: 16
  },

  idInput: {
    width: '50%'
  },

  streetInput: {
    marginTop: 15
  },

  cityContainer: {
    marginTop: 15,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },

  cityInput: {
    flex: 4,
    marginRight: 16
  },

  stateInput: {
    flex: 2,
    marginRight: 16
  },

  zipCodeInput: {
    flex: 1
  },

  contactContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 16
  },

  contactText: {
    color: '#757575',
    fontSize: 14
  },

  contactNameContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 11,
    flexWrap: 'wrap'
  },

  contactInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center'
  },

  addressContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: 16
  },

  addressInput: {
    flex: 1
  },

  contactFirstName: {
    flex: 1,
    marginRight: 16
  },

  contactLastName: {
    flex: 1
  },

  contactEmail: {
    flex: 3,
    marginRight: 16
  },

  contactPhone: {
    flex: 1
  },

  mailTo: {
    marginRight: 16,
    cursor: 'pointer',
    color: '#356992'
  },

  editCustomer: {
    marginTop: 16,
    cursor: 'pointer',
    color: '#356992',
    fontSize: 14
  }

}



// WEBPACK FOOTER //
// ./src/schedule/common/modules/text/ClientModule.js